<app-company-request [newCompany]="newCompany"></app-company-request>
<hr>
<div class="row">
	<h5>Datos de la reunión</h5>
	<div class="col">
		<div class="form-group">
			<label for="user" class="form-label">Encargado <i class="fa fa-asterisk text-danger"></i></label>
			<div class="input-group">
				<app-input-autocomplete (changeStatus)="selectUser($event.filterElement)" (inputMethod)="searchUser()"
					[allBorderRadius]="true" [filterElements]="users" [placeholder]="'Busca una usuario'"
					[custom]="true" [inputs]="inputs">
					<ng-template #itemsTemplate let-filter>
						<!-- This is the content that will be projected -->
						<div items>
							<h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
								{{filter.email}}</h5>
						</div>
					</ng-template>
				</app-input-autocomplete>
			</div>
		</div>
	</div>
	<div class="col form-group">
		<label for="date" class="form-label">Fecha y hora <i class="fa fa-asterisk text-danger"></i></label>
		<input type="datetime-local" [(ngModel)]="tempDate" (change)="seeDate($event)" name="date" id="date"
			class="form-control">
	</div>
</div>
<div class="row">
	<div class="col form-group">
		<label for="description" class="form-label">Descripción <i class="fa fa-asterisk text-danger"></i></label>
		<textarea name="description" [(ngModel)]="newCompanyRequest.description"
			placeholder="Ingresa información importante para la reunión" id="description"
			class="form-control"></textarea>
	</div>
	<div class="col">
		<label for="add-photo" class="form-label">Fotos de referencia <i class="fa fa-asterisk text-danger"></i></label>
		<section class="scrollport">
			<div class="add-photo" (click)="fileInput.click()">
				<i class="fa fa-circle-plus"></i>
			</div>
			<div *ngFor="let photo of photos; let i = index" style="background-image: url({{photo}});"
				(click)="photos.splice(i,1)">
				<div class="icon">
					<i class="fa fa-trash icon text-danger"></i>
				</div>
			</div>
		</section>
	</div>
</div>
<h5>Locación de la empresa</h5>
<ng-container *ngIf="lat!= null && lng !=null">
	<app-map [coordinates]="[{lat: lat, lng: lng}]" [allowSelect]="true" (selecting)="changingGeolocation($event)"></app-map>
</ng-container>
<input #fileInput type="file" accept="image/*" multiple (change)="onFileChange($event,fileInput)"
	style="display: none;">
<hr>
<app-loading-button [object]="buttonSave" [disabled]="getDisabledGeneral() || this.newCompany.activities.length == 0
			|| this.newCompany.contacts.length == 0
			|| this.newCompany.phones.length == 0
			|| this.photos.length == 0
			|| !this.newCompanyRequest.description
			|| !this.newCompanyRequest.date
			|| !this.newCompanyRequest.userId || !this.lat || !this.lng" (clicked)="saveRequest()"></app-loading-button>